import { request, METHOD } from '@/utils/request.js'

/**
 * 修改教师密码
 * @param {Object} data 
 * @param {string} data.password - 新密码
 */
export function updateTeacherPassword(data) {
  return request(
    '/h5Mfitness/login/updateTeacherPassword',
    METHOD.POST,
    data
  )
}


/**
 * 解绑教师账号
 * @param {Object} data
 * @param {string} data.schoolCode - 学校编码
 * @param {string} data.phoneNumber - 手机号
 */
export function unbindTeacherAccount(data) {
  return request(
     '/h5Mfitness/login/unbindTeacherAccount',
        METHOD.POST,
    data
  );
}

/**
 * 获取教师绑定的学校列表 (保留你之前代码里用到的接口)
 * @param {Object} data
 * @param {string} data.openId - 微信 openId
 */
export function getOneSchoolByTeacherOpenId(data) {
  return request(
     '/h5Mfitness/teacher/getOneSchoolByTeacherOpenId', // 请根据实际路径调整
        METHOD.POST,
    data
  );
}

   